<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      size="mini"
      label-width="100px"
      label-position="left"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_managementFeeRate') || '管理费率'"
            prop="managementFeeRate"
          >
            <el-input-number
              v-model="formData.managementFeeRate"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              style="width: 100%"
              :min="0"
              :max="999999.99"
              :step="0.01"
              :precision="2"
            ></el-input-number>
          </el-form-item>
          <div class="el-form-item pl-2">%</div>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_profitRate') || '毛利率'"
            prop="profitRate"
          >
            <el-input-number
              v-model="formData.profitRate"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              style="width: 100%"
              :min="0"
              :max="999999.99"
              :step="0.01"
              :precision="2"
            ></el-input-number>
          </el-form-item>
          <div class="el-form-item pl-2">%</div>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_vatRate') || '增值税率'"
            prop="vatRate"
          >
            <el-input-number
              v-model="formData.vatRate"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              style="width: 100%"
              :min="0"
              :max="999999.99"
              :step="0.01"
              :precision="2"
            ></el-input-number>
          </el-form-item>
          <div class="el-form-item pl-2">%</div>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: { pdCostsOrderCode: { type: String, default: '' } },
  data() {
    return {
      backDialogVisible: false,
      formData: {
        managementFeeRate: 0,
        profitRate: 0,
        vatRate: 0,
      },
      rules: {
        managementFeeRate: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        profitRate: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        vatRate: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.pdCostsOrderCode) return
      this.loading = true
      const res = await this.$api
        .pdCostsOrderDetailApi({ pdCostsOrderCode: this.pdCostsOrderCode })
        .catch(() => null)
      this.loading = false
      if (!res || !res.body) return
      const { managementFeeRate, profitRate, vatRate } = res.body
      this.formData = { managementFeeRate, profitRate, vatRate }
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      const params = {
        pdCostsOrderCode: this.pdCostsOrderCode,
        ...this.formData,
      }
      this.loadingOpen()
      const res = await this.$api
        .pdCostsOrderSetCostRateApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.$emit('reload')
      this.close()
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-col {
    display: flex;
    align-items: center;
  }
}
</style>
